import React, { Component } from 'react';

import Navigation from './Navigation';
import LandingPage from './LandingPage';
import AboutMe from './AboutMe';
import Career from './Career';
import Portfolio from './Portfolio';
import Contact from './Contact';
import Footer from './Footer';

import './css/App.css';

export class App extends Component {
	render() {
		return (
			<div>
				<Navigation />
				<LandingPage />
				<AboutMe />
				<Career />
				<Portfolio />
				{/* <Contact /> */}
				<Footer />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/App.js